import React from "react";
import { AppTranslation } from "../../../../../../i18n/useAppTranslation";
import { not } from "../../../../../../utilities/fp";

export function Settings({ syncAll, syncNew, setSyncAll, setSyncNew }) {
  return (
    <div className="row">
      <div className="col-xs-12 m-t-15">
        <p className="p-text">
          How do you want to sync? <span className="setting-require">*</span>
        </p>
      </div>
      <div className="col-xs-12">
        <div className="setting-custom-switch product-active pull-left m-t-10">
          <label className="setting-switch pull-left no-margin">
            <input
              type="checkbox"
              className="setting-custom-switch-input"
              name="all_patient"
              autoComplete="off"
              checked={syncAll ? "checked" : false}
              onChange={() => setSyncAll(not)}
              value={syncAll}
            />
            <span className="setting-slider"></span>
          </label>
          <span id="membership_lable" className="m-l-15 radioLabel">
            <AppTranslation.Settings path="allPatients" />
          </span>
        </div>
      </div>
      <div className="col-xs-12">
        <div className="setting-custom-switch product-active pull-left m-t-10 m-b-20">
          <label className="setting-switch pull-left no-margin">
            <input
              type="checkbox"
              className="setting-custom-switch-input"
              name="newly_created"
              autoComplete="off"
              checked={syncNew ? "checked" : false}
              onChange={() => setSyncNew(not)}
              value={syncNew}
            />
            <span className="setting-slider"></span>
          </label>
          <span id="membership_lable" className="m-l-15 radioLabel">
            Newly Created
          </span>
        </div>
      </div>
    </div>
  );
}
